import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PLATFORM, applyBranding, brandingFromHost } from "@/lib/branding";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [next, setNext] = useState(null);
  const [publicBrand, setPublicBrand] = useState(PLATFORM);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const { slug, host } = brandingFromHost();
    if (slug) sessionStorage.setItem("elm_ws", slug);
    api.get("/public/branding", { params: { slug, host } }).then((r) => setPublicBrand(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps -- bootstrap: run once on mount
  }, []);

  const workspace = user?.workspace;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- applyBranding is a stable module import
  useEffect(() => { applyBranding(workspace?.branding || publicBrand.branding); }, [workspace, publicBrand]);

  const signIn = useCallback((data, nextPath = null) => {
    setNext(nextPath);
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  const setWorkspace = useCallback((ws) => setUser((u) => (u ? { ...u, workspace: ws } : u)), []);
  const refreshWorkspace = useCallback(async () => { const { data } = await api.get("/workspace"); setWorkspace(data); return data; }, [setWorkspace]);
  const refreshUser = useCallback(async () => { const { data } = await api.get("/auth/me"); setUser(data); return data; }, []);

  const brand = workspace
    ? { name: workspace.name, slug: workspace.slug, branding: workspace.branding, white_label: workspace.state.limits.white_label, platform: false }
    : publicBrand;

  const beta = !!publicBrand.private_beta;

  return <AuthCtx.Provider value={{ user, next, workspace, brand, beta, signIn, logout, setWorkspace, refreshWorkspace, refreshUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
